// @flow
import { gql } from 'graphql-request';
import moment from 'moment';

import { runQuery } from '_client';
import { DbDateFormat } from '_utils/date';
import { GqlError } from '_utils/errors';

export const checkHasActiveSubscription = (currentUser: Object): boolean => {
  if (!currentUser) return false;

  if (currentUser.membership?.freeAppAccess) return true;

  if (!currentUser?.entitlement) {
    return false;
  }

  const expiryDate = moment(currentUser.entitlement.expiresDate, DbDateFormat);
  const currentDate = new Date();
  const expired = expiryDate.isBefore(currentDate);
  return !expired;
};

export const checkHasExpiredSubscription = (currentUser: Object): boolean => {
  if (!currentUser) return false;

  if (currentUser.membership?.freeAppAccess) return false;

  if (!currentUser?.entitlement) {
    return false;
  }

  const expiryDate = moment(currentUser.entitlement.expiresDate, DbDateFormat);
  const currentDate = new Date();
  const expired = expiryDate.isBefore(currentDate);
  return expired;
};

const SUBSCRIPTION_STATUS = gql`
  query me {
    me {
      id
      entitlement {
        subscriptionId
        purchaseDate
        expiresDate
        periodType
        planType
        store
        status
      }
    }
  }
`;

export const getSubscriptionStatus = async (): Promise<Object> => {
  try {
    const { me } = await runQuery(SUBSCRIPTION_STATUS);
    return me.entitlement;
  } catch (err) {
    throw new GqlError(err);
  }
};
